import * as setAccesibilityAttributesModule from "./accessibilityCustomLogic";
var initAccessibilityRadioGroups = (function () {
    'use strict';

    window.addEventListener('load', function () {
        var radioButtons = document.querySelectorAll('.btn-group-toggle [role=radio]');

        if (radioButtons.length) {
            for (var i = 0; i < radioButtons.length; i++) {
                var radioButton = radioButtons[i];

                radioButton.addEventListener('click', setAccesibilityAttributesModule.clickRadioGroup);
                radioButton.addEventListener('keydown', setAccesibilityAttributesModule.keyDownRadioGroup);
            }
        }
    });
})();